import { Checkbox, DataSource, Label, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiRequiredField extends Layout {
    checkboxIsActive: Checkbox;
    labelRulesTitle: Label;
    sourceEdiDataRule: DataSource;
    sourceEdiRequiredField: DataSource;
    tableEdiDataRule: Table;
    textboxFieldName: Textbox;
    textboxLocation: Textbox;
    textboxPassTest: Textbox;
    textboxRuleType: Textbox;
    textboxStopsToCheck: Textbox;
    textboxTableName: Textbox;
}
